module.exports = __webpack_public_path__ + "static/img/banner_4.96012223.png";